<template>
  <div>
    <div class="form-group">
      <div class="item-name">
        <label>世帯構成</label>
      </div>
      <div class="button-style">
        <label><input type="radio" value=1 v-model="houseHold" @change="changehouseHold" /><span>家族と同居</span></label>
        <label><input type="radio" value=2 v-model="houseHold" @change="changehouseHold" /><span>１人暮らし</span></label>
        <label><input type="radio" value=3 v-model="houseHold" @change="changehouseHold" /><span>施設入所</span></label>
      </div>
    </div>
    <div class="form-group" v-show="isActive">
      <div class="item-name"><label>同居家族</label><span>※複数選択可</span></div>
      <div class="button-style">
        <label><input type="checkbox" value="配偶者" v-model="familyLivingTogether" @change="changeFamilyLivingTogether"/><span>配偶者</span></label>
        <label><input type="checkbox" value="兄弟姉妹" v-model="familyLivingTogether" @change="changeFamilyLivingTogether"/><span>兄弟姉妹</span></label>
        <label><input type="checkbox" value="子" v-model="familyLivingTogether" @change="changeFamilyLivingTogether"/><span>子</span></label>
        <label><input type="checkbox" value="孫" v-model="familyLivingTogether" @change="changeFamilyLivingTogether"/><span>孫</span></label>
        <label><input type="checkbox" value="その他" v-model="familyLivingTogether" @change="changeFamilyLivingTogether"/><span>その他</span></label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      houseHold: "",
      familyLivingTogether: [],
    };
  },
  methods: {
    changehouseHold(e) {
      if (e.target.value == 1) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
      this.houseHold = e.target.value
      this.$emit("handle-change-household",this.houseHold)
    },
    changeFamilyLivingTogether() {
      this.$emit("handle-change-familylivingtogether", this.familyLivingTogether)
    }
  },
};
</script>

<style scoped>
label {
  margin-right: 5px; /* ボタン同士の間隔 */
}

label input {
  display: none; /* デフォルトのinputは非表示にする */
}

label span {
  color: gray;
  font-size: 1rem;
  border: 1px solid gainsboro;
  border-radius: 25px;
  padding: 3% 2%;
  display: inline-block;
  text-align: center;
  min-width: 25%;
  margin-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputHousehold.vue